module.exports = __webpack_public_path__ + "static/media/11-IMG_6721.7b6f4f6f.JPG";